(function () {
  function initStaynaFaq(root) {
    if (!root || root.dataset.staynaInit === "1") return;
    root.dataset.staynaInit = "1";

    // Tabs
    const tabButtons = root.querySelectorAll(".stayna-tab-btn");
    const tabContents = root.querySelectorAll(".stayna-tab-content");

    tabButtons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();

        const target = btn.getAttribute("data-tab");
        if (!target) return;

        tabButtons.forEach((b) => b.classList.remove("active"));
        tabContents.forEach((c) => c.classList.remove("active"));

        btn.classList.add("active");
        const targetEl = root.querySelector("#" + CSS.escape(target));
        if (targetEl) targetEl.classList.add("active");
      });
    });

    // Accordion
    root.querySelectorAll(".stayna-item .stayna-question").forEach((q) => {
      q.addEventListener("click", (e) => {
        e.preventDefault();
        const item = q.closest(".stayna-item");
        if (item) item.classList.toggle("open");
      });
    });
  }

  function boot() {
    document.querySelectorAll(".stayna-faq").forEach(initStaynaFaq);
  }

  // 1) Load initial
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  // 2) Shopify editor / dynamic sections (important)
  document.addEventListener("shopify:section:load", boot);
})();
